import { useEffect } from 'react';

// Ademero's current privacy policy covers its websites and applications,
// including this app. The 2020 Nucleus One policy that used to be framed here
// (public/privacy.html) is kept, no longer served, in
// legal-archive/privacy-2020-09-17.html.
export const PRIVACY_POLICY_URL = 'https://www.ademero.com/privacy';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.location.replace(PRIVACY_POLICY_URL);
  }, []);

  return null;
}
